export const translations = {
  es: {
    // Navigation
    nav: {
      home: "Inicio",
      howItWorks: "Cómo Funciona",
      eLearning: "E-Learning",
      plans: "Planes",
      altoRendimiento: "Alto Rendimiento",
      academy: "Academy",
      registerPlayer: "Registrar Jugador",
      enrollMyChild: "Inscribir a mi hijo"
    },

    // Hero Section
    hero: {
      badge: "La primera agencia de fútbol infantil por suscripción en LATAM",
      title1: "El futuro del fútbol",
      title2: "comienza a los",
      title3: "años",
      subtitle: "No solo entrenamos niños. Construimos su marca personal, creamos su contenido profesional y los representamos para las oportunidades que vendrán.",
      cta1: "Comenzar ahora",
      cta2: "Hablar por WhatsApp",
      stats: {
        activeKids: "Niños activos",
        countries: "Países LATAM",
        videosCreated: "Videos creados",
        connectedScouts: "Scouts conectados"
      }
    },

    // Pillars Section
    pillars: {
      badge: "SISTEMA INTEGRAL",
      title: "Tres mundos en uno solo",
      subtitle: "No vendemos solo videos ni entrenamiento. Vendemos un sistema real de proyección deportiva y visibilidad temprana.",
      items: [
        {
          title: "Formación Deportiva",
          subtitle: "Entrenamiento profesional",
          description: "Jornadas mensuales con entrenadores certificados. Metodología europea adaptada para el desarrollo técnico, táctico y físico de cada niño.",
          features: ["Entrenador profesional", "Metodología por edades", "Evaluación mensual"]
        },
        {
          title: "Marca Personal",
          subtitle: "Contenido profesional",
          description: "Equipo audiovisual en cada sesión. Creamos videos de alta calidad para YouTube y redes sociales. Tu hijo como protagonista.",
          features: ["Videos HD mensuales", "Edición profesional", "Publicación semanal"]
        },
        {
          title: "Representación",
          subtitle: "Oportunidades reales",
          description: "Perfil público indexado en Google. Conexión con scouts, equipos y marcas. Representación legal para contratos futuros.",
          features: ["Perfil web público", "Red de scouts", "Representación legal"]
        }
      ]
    },

    // Included Section
    included: {
      title: "Todo esto incluido cada mes",
      subtitle: "Una suscripción, acceso completo al sistema",
      items: [
        { title: "1 jornada profesional mensual", desc: "Con entrenador y equipo audiovisual" },
        { title: "Videos de alta calidad", desc: "Editados profesionalmente cada mes" },
        { title: "Publicación semanal", desc: "En el canal de ProKids Talent" },
        { title: "Perfil web público", desc: "Indexado en Google para scouts" },
        { title: "Ecosistema de la agencia", desc: "Comunidad de talentos y familias" },
        { title: "Representación incluida", desc: "Para marcas y oportunidades deportivas" }
      ],
      bonus: {
        title: "Bonus: Tu contenido, tus redes",
        description: "Todo el material generado también puede ser usado en las redes personales del jugador. Construye su audiencia desde el primer día."
      }
    },

    // E-Learning Section
    eLearning: {
      badge: "ACADEMIA VIRTUAL",
      title: "E-Learning ProKids",
      subtitle: "+140 videos de entrenamiento profesional. Aprende las mejores técnicas desde casa, a tu ritmo.",
      categories: [
        { title: "Técnica Individual", description: "Control de balón, pases, regates y finalizaciones" },
        { title: "Pliometría y Físico", description: "Ejercicios de potencia, velocidad y coordinación" },
        { title: "Jugadas Tácticas", description: "Movimientos de equipo, posicionamiento y estrategia" },
        { title: "Mentalidad Deportiva", description: "Concentración, manejo de presión y motivación" },
        { title: "Nutrición Deportiva", description: "Alimentación para jóvenes atletas de alto rendimiento" }
      ],
      featuredVideos: "Videos Destacados",
      viewAll: "Ver todos →",
      videosLabel: "videos",
      cta: "Ver planes y precios",
      accessIncluded: "Acceso completo a la academia incluido en todos los planes"
    },

    // Pricing Section
    pricing: {
      badge: "INVERSIÓN EN SU FUTURO",
      title: "Elige el plan perfecto",
      subtitle: "Sin costos ocultos. Sin contratos largos. Cancela cuando quieras.",
      monthly: "Mensual",
      yearly: "Anual",
      discount: "-20%",
      billedYearly: "Facturado anualmente",
      mostPopular: "Más popular",
      paymentMethods: "Aceptamos pagos de toda Latinoamérica",
      plans: [
        {
          name: "Starter",
          description: "Ideal para comenzar",
          cta: "Comenzar ahora",
          features: [
            { text: "Acceso completo al E-Learning", included: true },
            { text: "+140 videos de entrenamiento", included: true },
            { text: "Comunidad de padres y jugadores", included: true },
            { text: "Nuevos videos cada semana", included: true },
            { text: "Jornada mensual presencial", included: false },
            { text: "Videos personales del jugador", included: false },
            { text: "Perfil web público", included: false },
            { text: "Representación deportiva", included: false }
          ]
        },
        {
          name: "Pro",
          description: "El más popular",
          cta: "Elegir Pro",
          features: [
            { text: "Todo lo de Starter +", included: true },
            { text: "1 jornada presencial mensual", included: true },
            { text: "Videos HD personalizados", included: true },
            { text: "Publicación semanal en redes", included: true },
            { text: "Perfil web público indexado", included: true },
            { text: "Uso libre del contenido", included: true },
            { text: "Soporte prioritario WhatsApp", included: true },
            { text: "Representación activa con scouts", included: false }
          ]
        },
        {
          name: "Elite",
          description: "Máxima proyección",
          cta: "Elegir Elite",
          features: [
            { text: "Todo lo de Pro +", included: true },
            { text: "Representación activa", included: true },
            { text: "Conexión directa con scouts", included: true },
            { text: "Prioridad en oportunidades", included: true },
            { text: "Videos premium exclusivos", included: true },
            { text: "Evaluación técnica trimestral", included: true },
            { text: "Asesoría personalizada", included: true },
            { text: "Acceso a eventos especiales", included: true }
          ]
        }
      ]
    },

    // Testimonials Section
    testimonials: {
      title: "Familias que confían en nosotros",
      subtitle: "Historias reales de nuestra comunidad",
      items: [
        {
          name: "María González",
          role: "Mamá de Diego, 8 años",
          location: "Guadalajara, México",
          text: "Diego ha crecido muchísimo no solo como jugador, sino en confianza. Ver sus videos profesionales y su perfil en la web lo motiva a seguir mejorando cada día."
        },
        {
          name: "Carlos Rodríguez",
          role: "Papá de Mateo, 10 años",
          location: "Bogotá, Colombia",
          text: "Ya tuvimos el primer contacto de un scout gracias al perfil de Mateo. La inversión vale cada centavo cuando ves las oportunidades que se abren."
        },
        {
          name: "Ana Martínez",
          role: "Mamá de Valentina, 7 años",
          location: "Buenos Aires, Argentina",
          text: "Nunca imaginé que mi hija tendría un perfil profesional a los 7 años. ProKids no solo entrena, construye el futuro de nuestros hijos."
        }
      ]
    },

    // Sponsors Section
    sponsors: {
      badge: "NUESTROS AUSPICIADORES",
      title: "Marcas que nos respaldan",
      subtitle: "Grandes marcas confían en ProKids Talent y apoyan nuestros eventos para impulsar el talento juvenil de Latinoamérica.",
      goldTier: "SPONSORS GOLD",
      silverTier: "SPONSORS SILVER",
      becomeSponsor: {
        title: "¿Quieres ser auspiciador?",
        description: "Conecta tu marca con el futuro del fútbol latinoamericano. Miles de familias en nuestros eventos.",
        cta: "Contactar ahora"
      },
      stats: {
        events: "Eventos anuales",
        attendees: "Asistentes",
        countries: "Países LATAM",
        reach: "Alcance en redes"
      }
    },

    // FAQ Section
    faq: {
      title: "Preguntas frecuentes",
      subtitle: "Todo lo que necesitas saber antes de inscribir a tu hijo",
      items: [
        {
          question: "¿Desde qué edad pueden inscribirse?",
          answer: "Aceptamos niños y niñas desde los 5 años hasta los 18 años. Cada grupo de edad tiene metodología adaptada a su etapa de desarrollo."
        },
        {
          question: "¿Dónde se realizan las jornadas de entrenamiento?",
          answer: "Tenemos sedes en las principales ciudades de México, Colombia, Argentina, Chile y Perú. También organizamos jornadas especiales en otras ciudades con previo aviso."
        },
        {
          question: "¿Qué pasa si un mes no podemos asistir?",
          answer: "Entendemos que la vida familiar es compleja. Si no puedes asistir un mes, tu suscripción se pausa sin costo y se retoma el siguiente mes. Sin penalizaciones."
        },
        {
          question: "¿El contenido es realmente mío?",
          answer: "Sí. Todo el contenido generado puede ser usado en las redes personales del jugador. Tú mantienes los derechos sobre la imagen de tu hijo."
        },
        {
          question: "¿Cómo funciona la representación?",
          answer: "Cuando una marca o equipo muestra interés en tu hijo, nosotros actuamos como representantes. Negociamos en su nombre y te asesoramos en cada paso. Este servicio está incluido sin costo adicional."
        },
        {
          question: "¿Puedo cancelar cuando quiera?",
          answer: "Absolutamente. No hay contratos de permanencia. Puedes cancelar tu suscripción en cualquier momento desde tu cuenta o contactándonos por WhatsApp."
        }
      ]
    },

    // CTA Section
    cta: {
      title1: "El próximo crack de Latinoamérica",
      title2: "podría ser tu hijo",
      subtitle: "No esperes a que sea tarde. El sistema de proyección comienza hoy. Inscríbelo y dale la ventaja que merece.",
      button1: "Inscribir ahora por $79/mes",
      button2: "Hablar por WhatsApp"
    },

    // Footer
    footer: {
      description: "La primera agencia de fútbol infantil por suscripción en Latinoamérica.",
      links: {
        title: "Enlaces",
        howItWorks: "Cómo funciona",
        pricing: "Planes y precios",
        players: "Perfiles de jugadores",
        blog: "Blog"
      },
      legal: {
        title: "Legal",
        terms: "Términos y condiciones",
        privacy: "Política de privacidad",
        minors: "Protección de menores"
      },
      social: {
        title: "Síguenos"
      },
      questions: "¿Preguntas?",
      copyright: "© 2025 ProKids Talent. Todos los derechos reservados.",
      allLatam: "Toda Latinoamérica"
    },

    // Contact Page
    contact: {
      badge: "CONTÁCTANOS",
      title: "Inscribe a tu hijo hoy",
      subtitle: "Completa el formulario y nos pondremos en contacto contigo en menos de 24 horas.",
      backToHome: "Volver al inicio",
      form: {
        parentTitle: "Datos del padre/madre",
        playerTitle: "Datos del jugador",
        fullName: "Nombre completo",
        email: "Correo electrónico",
        phone: "Teléfono / WhatsApp",
        city: "Ciudad / País",
        childName: "Nombre del niño/a",
        age: "Edad",
        selectAge: "Selecciona la edad",
        years: "años",
        message: "Mensaje (opcional)",
        messagePlaceholder: "¿Tienes alguna pregunta o comentario?",
        submit: "Enviar solicitud",
        sending: "Enviando...",
        success: {
          title: "¡Mensaje enviado!",
          subtitle: "Gracias por tu interés. Te contactaremos pronto.",
          another: "Enviar otro mensaje"
        },
        error: "Hubo un error al enviar el mensaje. Por favor intenta de nuevo o contáctanos por WhatsApp."
      },
      sidebar: {
        directContact: "Contacto directo",
        whyProKids: "¿Por qué ProKids?",
        reasons: [
          "Sistema integral de desarrollo",
          "Contenido profesional incluido",
          "Representación deportiva",
          "Sin contratos a largo plazo"
        ],
        fastResponse: "Respuesta rápida",
        responseTime: "Te contactamos en menos de 24 horas"
      }
    },

    // Player Registration
    registration: {
      badge: "REGISTRO DE JUGADOR",
      title: "Crea el perfil de tu hijo",
      subtitle: "Completa el formulario y empieza a construir su carrera",
      steps: {
        info: "Información",
        received: "Datos Recibidos",
        review: "Revisión",
        publish: "Publicación"
      }
    },

    // Common
    common: {
      month: "/mes",
      learnMore: "Saber más",
      viewProfile: "Ver perfil",
      verified: "VERIFICADO",
      memberSince: "Miembro desde"
    }
  },

  en: {
    // Navigation
    nav: {
      home: "Home",
      howItWorks: "How It Works",
      eLearning: "E-Learning",
      plans: "Plans",
      altoRendimiento: "High Performance",
      academy: "Academy",
      registerPlayer: "Register Player",
      enrollMyChild: "Enroll my child"
    },

    // Alto Rendimiento
    altoRendimiento: {
      heroBadge: 'New Program 2026',
      heroTitle: 'High',
      heroTitleHighlight: 'Performance Training',
      heroSubtitle: 'Intensive program for cadetes and players who dream of making it into cadetes. Designed for kids aged 8 to 10 who want to take their soccer to the next level.',
      heroLocation: '📍 Club Deportivo Palestino, Las Condes · Fridays 4:30 to 6:30 PM',
      heroCTA: 'Reserve your spot now!',
      heroSecondary: 'See the program',
      stat1: 'of training', stat2: 'coaches on field', stat3: 'max capacity', stat4: 'performance tests',
      pillarsTitle: 'Comprehensive methodology',
      pillarsSubtitle: 'We train complete players with a focus on 4 fundamental pillars.',
      pillar1: 'Technical', pillar1Desc: 'Ball control, passing, receiving and finishing with progressive methodology.',
      pillar2: 'Physical', pillar2Desc: 'Age-adapted physical preparation: speed, coordination and endurance.',
      pillar3: 'Tactical', pillar3Desc: 'Game reading, decision making and understanding of space.',
      pillar4: 'Mental', pillar4Desc: 'Focus, discipline, resilience and teamwork.',
      planTitle: 'Training plan',
      planSubtitle: '120 minutes designed to maximize every second on the field. 1:8 ratio with two specialized coaches.',
      block1Title: 'Dynamic warm-up', block1Desc: 'Warm-up with ball, joint mobility and neuromuscular activation games.',
      block2Title: 'Coordination & movement', block2Desc: 'Agility circuits, balance, reaction speed and footwork (ABC of movement).',
      block3Title: 'Individual technique', block3Desc: 'Dribbling, oriented control, short/long passing and finishing. Station work with personalized correction.',
      block4Title: 'Small-sided games', block4Desc: '1v1, 2v2 and 3v3 situations to apply technique under real pressure. Decision making in tight spaces.',
      block5Title: 'Tactics & directed play', block5Desc: '5v5/7v7 matches with tactical instructions: off-ball movement, pressing, transitions and space creation.',
      block6Title: 'Free play + challenges', block6Desc: 'Free competition with individual and group challenges. Penalties, free kicks and technical challenges.',
      block7Title: 'Cool down & feedback', block7Desc: 'Stretching, group reflection and personalized feedback from coaches.',
      testsTitle: 'Performance tests',
      testsSubtitle: 'We measure your child\'s real progress every 6 weeks with a battery of 6 physical and technical tests. You will receive a detailed report with evolution.',
      test1: '20m Sprint', test1Desc: 'Explosive straight-line speed',
      test2: 'T-Test agility', test2Desc: 'Direction changes and lateral speed',
      test3: 'Standing long jump', test3Desc: 'Lower body power',
      test4: 'Slalom with ball', test4Desc: 'Technical dribbling under time pressure',
      test5: 'Target passing', test5Desc: 'Short and long pass accuracy',
      test6: 'Shooting at goal', test6Desc: 'Finishing: power and accuracy',
      testsNote: 'Each player will receive a ProKids Report with evolution charts and improvement recommendations',
      includesTitle: 'What\'s included?',
      includesList: [
        '2 hours of intensive weekly training',
        '2 specialized coaches on field (1:8 ratio)',
        'Battery of 6 performance tests every 6 weeks',
        'Individual report with metrics and evolution',
        'Synthetic grass field at Club Palestino',
        'European youth development methodology',
        'Small groups: maximum 16 players',
        'Personalized feedback every session',
      ],
      detailsTitle: 'Program details',
      detailDay: 'Day', detailDayVal: 'Fridays',
      detailTime: 'Schedule', detailTimeVal: '4:30 to 6:30 PM',
      detailLocation: 'Location', detailLocationVal: 'Club Deportivo Palestino, Las Condes, Santiago',
      detailAge: 'Age', detailAgeVal: '8 to 10 years (cadetes & aspirants)',
      detailCoaches: 'Coaches', detailCoachesVal: '2 coaches on field',
      detailCapacity: 'Capacity', detailCapacityVal: 'Maximum 16 players',
      pricingLabel: 'Monthly investment',
      pricingNote: '4 monthly classes of 2 hours · Everything included',
      pricingFeatures: [
        '4 monthly classes of 120 min',
        '2 specialized coaches',
        'Performance tests every 6 weeks',
        'Individual progress report',
        'Synthetic grass field (Palestino)',
        'No enrollment fee · No annual commitment',
      ],
      pricingCTA: 'Enroll my child!',
      pricingDisclaimer: 'Limited spots · Starting May 2026',
      faqTitle: 'Frequently asked questions',
      faqs: [
        { q: 'Does my child need previous experience?', a: 'Yes, the program is high performance and designed for cadetes or kids aspiring to make it into cadetes. They must have a technical foundation and play regularly at a club or soccer school.' },
        { q: 'Does the program prepare kids to make it into cadetes?', a: 'Exactly. The plan is designed to give 8 to 10 year olds the technical, physical, tactical and mental tools they need to stand out in cadete tryouts and maintain their level once in.' },
        { q: 'What if it rains or there\'s bad weather?', a: 'Palestino\'s field is synthetic grass, so we play in most conditions. In case of suspension, the session is rescheduled.' },
        { q: 'How often are performance tests?', a: 'Every 6 weeks we run the full battery of tests. You\'ll receive a report with evolution charts and personalized recommendations.' },
        { q: 'Can I enroll my child at any time?', a: 'Yes, you can join at any time as long as spots are available. The program is designed to integrate new players.' },
        { q: 'What should my child bring?', a: 'Comfortable sportswear, shin guards, soccer shoes (preferably for synthetic grass), water bottle and sunscreen.' },
      ],
      ctaTitle: 'Ready for the next level?',
      ctaSubtitle: 'Spots are limited to 16 players to ensure personalized attention. Reserve your child\'s place today.',
      ctaCTA: 'Reserve a spot!',
      ctaWhatsapp: 'Ask via WhatsApp',
      footerText: 'All rights reserved.',
    },

    // Hero Section
    hero: {
      badge: "The first youth soccer agency by subscription in LATAM",
      title1: "The future of soccer",
      title2: "starts at",
      title3: "years old",
      subtitle: "We don't just train kids. We build their personal brand, create professional content, and represent them for upcoming opportunities.",
      cta1: "Get started",
      cta2: "Chat on WhatsApp",
      stats: {
        activeKids: "Active kids",
        countries: "LATAM Countries",
        videosCreated: "Videos created",
        connectedScouts: "Connected scouts"
      }
    },

    // Pillars Section
    pillars: {
      badge: "COMPLETE SYSTEM",
      title: "Three worlds in one",
      subtitle: "We don't just sell videos or training. We sell a real system for sports projection and early visibility.",
      items: [
        {
          title: "Sports Training",
          subtitle: "Professional coaching",
          description: "Monthly sessions with certified coaches. European methodology adapted for the technical, tactical, and physical development of each child.",
          features: ["Professional coach", "Age-based methodology", "Monthly evaluation"]
        },
        {
          title: "Personal Brand",
          subtitle: "Professional content",
          description: "Audiovisual team at every session. We create high-quality videos for YouTube and social media. Your child as the protagonist.",
          features: ["Monthly HD videos", "Professional editing", "Weekly publishing"]
        },
        {
          title: "Representation",
          subtitle: "Real opportunities",
          description: "Public profile indexed on Google. Connection with scouts, teams, and brands. Legal representation for future contracts.",
          features: ["Public web profile", "Scout network", "Legal representation"]
        }
      ]
    },

    // Included Section
    included: {
      title: "All this included every month",
      subtitle: "One subscription, complete access to the system",
      items: [
        { title: "1 professional session monthly", desc: "With coach and audiovisual team" },
        { title: "High-quality videos", desc: "Professionally edited each month" },
        { title: "Weekly publishing", desc: "On the ProKids Talent channel" },
        { title: "Public web profile", desc: "Indexed on Google for scouts" },
        { title: "Agency ecosystem", desc: "Community of talents and families" },
        { title: "Representation included", desc: "For brands and sports opportunities" }
      ],
      bonus: {
        title: "Bonus: Your content, your networks",
        description: "All generated material can also be used on the player's personal social media. Build their audience from day one."
      }
    },

    // E-Learning Section
    eLearning: {
      badge: "VIRTUAL ACADEMY",
      title: "ProKids E-Learning",
      subtitle: "+140 professional training videos. Learn the best techniques from home, at your own pace.",
      categories: [
        { title: "Individual Technique", description: "Ball control, passes, dribbles, and finishing" },
        { title: "Plyometrics & Fitness", description: "Power, speed, and coordination exercises" },
        { title: "Tactical Plays", description: "Team movements, positioning, and strategy" },
        { title: "Sports Mindset", description: "Focus, pressure management, and motivation" },
        { title: "Sports Nutrition", description: "Nutrition for young high-performance athletes" }
      ],
      featuredVideos: "Featured Videos",
      viewAll: "View all →",
      videosLabel: "videos",
      cta: "See plans and pricing",
      accessIncluded: "Full academy access included in all plans"
    },

    // Pricing Section
    pricing: {
      badge: "INVEST IN THEIR FUTURE",
      title: "Choose the perfect plan",
      subtitle: "No hidden costs. No long contracts. Cancel anytime.",
      monthly: "Monthly",
      yearly: "Yearly",
      discount: "-20%",
      billedYearly: "Billed annually",
      mostPopular: "Most popular",
      paymentMethods: "We accept payments from all of Latin America",
      plans: [
        {
          name: "Starter",
          description: "Ideal to begin",
          cta: "Get started",
          features: [
            { text: "Full E-Learning access", included: true },
            { text: "+140 training videos", included: true },
            { text: "Parents and players community", included: true },
            { text: "New videos every week", included: true },
            { text: "Monthly in-person session", included: false },
            { text: "Personal player videos", included: false },
            { text: "Public web profile", included: false },
            { text: "Sports representation", included: false }
          ]
        },
        {
          name: "Pro",
          description: "Most popular",
          cta: "Choose Pro",
          features: [
            { text: "Everything in Starter +", included: true },
            { text: "1 monthly in-person session", included: true },
            { text: "Personalized HD videos", included: true },
            { text: "Weekly social media posting", included: true },
            { text: "Indexed public web profile", included: true },
            { text: "Free use of content", included: true },
            { text: "Priority WhatsApp support", included: true },
            { text: "Active representation with scouts", included: false }
          ]
        },
        {
          name: "Elite",
          description: "Maximum projection",
          cta: "Choose Elite",
          features: [
            { text: "Everything in Pro +", included: true },
            { text: "Active representation", included: true },
            { text: "Direct connection with scouts", included: true },
            { text: "Priority for opportunities", included: true },
            { text: "Exclusive premium videos", included: true },
            { text: "Quarterly technical evaluation", included: true },
            { text: "Personalized consulting", included: true },
            { text: "Access to special events", included: true }
          ]
        }
      ]
    },

    // Testimonials Section
    testimonials: {
      title: "Families that trust us",
      subtitle: "Real stories from our community",
      items: [
        {
          name: "María González",
          role: "Diego's mom, 8 years old",
          location: "Guadalajara, Mexico",
          text: "Diego has grown so much not only as a player but in confidence. Seeing his professional videos and profile on the web motivates him to keep improving every day."
        },
        {
          name: "Carlos Rodríguez",
          role: "Mateo's dad, 10 years old",
          location: "Bogotá, Colombia",
          text: "We already had our first contact from a scout thanks to Mateo's profile. The investment is worth every penny when you see the opportunities that open up."
        },
        {
          name: "Ana Martínez",
          role: "Valentina's mom, 7 years old",
          location: "Buenos Aires, Argentina",
          text: "I never imagined my daughter would have a professional profile at 7 years old. ProKids doesn't just train, it builds our children's future."
        }
      ]
    },

    // Sponsors Section
    sponsors: {
      badge: "OUR SPONSORS",
      title: "Brands that support us",
      subtitle: "Major brands trust ProKids Talent and support our events to promote youth talent in Latin America.",
      goldTier: "GOLD SPONSORS",
      silverTier: "SILVER SPONSORS",
      becomeSponsor: {
        title: "Want to become a sponsor?",
        description: "Connect your brand with the future of Latin American soccer. Thousands of families at our events.",
        cta: "Contact now"
      },
      stats: {
        events: "Annual events",
        attendees: "Attendees",
        countries: "LATAM Countries",
        reach: "Social reach"
      }
    },

    // FAQ Section
    faq: {
      title: "Frequently asked questions",
      subtitle: "Everything you need to know before enrolling your child",
      items: [
        {
          question: "From what age can they enroll?",
          answer: "We accept boys and girls from 5 to 18 years old. Each age group has methodology adapted to their development stage."
        },
        {
          question: "Where are the training sessions held?",
          answer: "We have locations in major cities in Mexico, Colombia, Argentina, Chile, and Peru. We also organize special sessions in other cities with advance notice."
        },
        {
          question: "What happens if we can't attend one month?",
          answer: "We understand family life can be complex. If you can't attend one month, your subscription pauses at no cost and resumes the following month. No penalties."
        },
        {
          question: "Is the content really mine?",
          answer: "Yes. All generated content can be used on the player's personal social media. You retain the rights to your child's image."
        },
        {
          question: "How does representation work?",
          answer: "When a brand or team shows interest in your child, we act as representatives. We negotiate on their behalf and advise you every step of the way. This service is included at no additional cost."
        },
        {
          question: "Can I cancel anytime?",
          answer: "Absolutely. There are no long-term contracts. You can cancel your subscription anytime from your account or by contacting us via WhatsApp."
        }
      ]
    },

    // CTA Section
    cta: {
      title1: "The next Latin American star",
      title2: "could be your child",
      subtitle: "Don't wait until it's too late. The projection system starts today. Enroll them and give them the advantage they deserve.",
      button1: "Enroll now for $79/month",
      button2: "Chat on WhatsApp"
    },

    // Footer
    footer: {
      description: "The first youth soccer agency by subscription in Latin America.",
      links: {
        title: "Links",
        howItWorks: "How it works",
        pricing: "Plans and pricing",
        players: "Player profiles",
        blog: "Blog"
      },
      legal: {
        title: "Legal",
        terms: "Terms and conditions",
        privacy: "Privacy policy",
        minors: "Child protection"
      },
      social: {
        title: "Follow us"
      },
      questions: "Questions?",
      copyright: "© 2025 ProKids Talent. All rights reserved.",
      allLatam: "All Latin America"
    },

    // Contact Page
    contact: {
      badge: "CONTACT US",
      title: "Enroll your child today",
      subtitle: "Complete the form and we'll contact you within 24 hours.",
      backToHome: "Back to home",
      form: {
        parentTitle: "Parent/Guardian information",
        playerTitle: "Player information",
        fullName: "Full name",
        email: "Email address",
        phone: "Phone / WhatsApp",
        city: "City / Country",
        childName: "Child's name",
        age: "Age",
        selectAge: "Select age",
        years: "years old",
        message: "Message (optional)",
        messagePlaceholder: "Do you have any questions or comments?",
        submit: "Send request",
        sending: "Sending...",
        success: {
          title: "Message sent!",
          subtitle: "Thank you for your interest. We'll contact you soon.",
          another: "Send another message"
        },
        error: "There was an error sending the message. Please try again or contact us via WhatsApp."
      },
      sidebar: {
        directContact: "Direct contact",
        whyProKids: "Why ProKids?",
        reasons: [
          "Comprehensive development system",
          "Professional content included",
          "Sports representation",
          "No long-term contracts"
        ],
        fastResponse: "Fast response",
        responseTime: "We contact you within 24 hours"
      }
    },

    // Player Registration
    registration: {
      badge: "PLAYER REGISTRATION",
      title: "Create your child's profile",
      subtitle: "Complete the form and start building their career",
      steps: {
        info: "Information",
        received: "Data Received",
        review: "Review",
        publish: "Publication"
      }
    },

    // Common
    common: {
      month: "/month",
      learnMore: "Learn more",
      viewProfile: "View profile",
      verified: "VERIFIED",
      memberSince: "Member since"
    }
  }
};
